import { render, staticRenderFns } from "./Dimmed.vue?vue&type=template&id=bc5936d0&scoped=true"
import script from "./Dimmed.vue?vue&type=script&lang=js"
export * from "./Dimmed.vue?vue&type=script&lang=js"
import style0 from "./Dimmed.vue?vue&type=style&index=0&id=bc5936d0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5936d0",
  null
  
)

export default component.exports